import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router } from "@angular/router";
import { catchError, lastValueFrom, of } from "rxjs";
import { UserBackend } from "src/app/backend/api/user.backend";
import { sntLog } from "src/app/common/logger";
import { getActivatedRouteMergedParamsFromRootToLastChild } from "src/app/support/activated-route";

const logger = sntLog("SkipOnboardingGuard");

@Injectable()
export class SkipOnboardingGuard implements CanActivate {
  readonly #userBackend = inject(UserBackend);
  readonly #router = inject(Router);

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    logger.info("canActivate");

    const { domain } = getActivatedRouteMergedParamsFromRootToLastChild(route);

    const currentMember = await lastValueFrom(
      this.#userBackend
        .loadMemberByDomain({ domain })
        .pipe(catchError(() => of(null)))
    );

    if (currentMember) {
      // TODO correggere redirect
      logger.info("skipped");
      this.#router.navigate(["/", domain]);
      return false;
    }

    logger.info("continue");
    return true;
  }
}
